import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface AvantiBrandIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

/**
 * The supplied artwork is a 150 square whose mark fills ~83% of the box, where
 * the other brand marks fill ~71% of theirs. The padded viewBox keeps the mark
 * centred on (75, 75) while scaling it to match.
 */
function AvantiBrandSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const fillColor = variant === "light" ? "currentColor" : "#44403C";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="-12.1 -12.1 174.2 174.2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Avanti</title>
      <path
        d="m75,128.46c-29.53,0 -53.48,-23.94 -53.48,-53.48s23.94,-53.48 53.48,-53.48s53.48,23.94 53.48,53.48s-23.94,53.48 -53.48,53.48m0,-115.3c-34.1,0 -61.84,27.74 -61.84,61.84s27.74,61.84 61.84,61.84s61.84,-27.74 61.84,-61.84s-27.74,-61.84 -61.84,-61.84"
        fill={fillColor}
      />
      <path
        d="m95.69,80.32s-3.75,-1.82 -5.13,-1.42c0,0 1.22,0.94 2.37,1.08c0,0 -1.28,1.31 -4.04,-0.18l-2.76,-1.49s5.32,-3.31 9.56,2.01m-7.27,27.35c-14.03,0 -10.83,-10.32 -7.85,-13.06c1.17,-2 12.71,-10.76 21.38,-2.61c0,0 4.24,-5.57 -2.18,-9.27c0,0 -0.68,-16.65 -29.66,-8.27c0,0 -0.3,-33.43 36.54,-31.76c0,0 -16.49,-13.23 -36.16,-0.9c0,0 -9.17,5.87 -12.4,16.15c0,0 -0.44,-19.86 18.2,-27.34c-11.51,-1.16 -21.21,4.36 -26.8,12.79c-4.58,7.42 -7.42,17.14 -1.83,30.92c0,0 -11.37,-8.74 -9.31,-22.89c-4.77,6.19 -6.78,13.54 -4.35,23.77c2.36,9.95 10.81,17.41 18.14,19.09c-5.22,0.98 -13.28,-0.03 -19.15,-8.3c0,0 8.13,33.19 42.72,33.19c27.32,-0.69 37.86,-21.24 37.86,-21.24c0,0 -11.12,9.72 -25.15,9.72"
        fill={fillColor}
      />
    </svg>
  );
}

export function IconAvantiBrand(props: AvantiBrandIconProps) {
  return (
    <IconWrapper {...props}>
      <AvantiBrandSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
